import { getStore } from 'store/store';
// @ts-ignore
// eslint-disable-next-line import/default
import Pilot from 'system/libs/Pilot';

import { CurrentUserModule } from 'reactApp/modules/CurrentUserModule/CurrentUserModule';

const router = {
    init(routes, target) {
        const pilot = Pilot.create(routes);

        pilot.listenFrom(target, {
            autoStart: true,
            filter(url) {
                // Allow anchor navigation on pages
                if (url.includes('#')) {
                    return false;
                }

                const pathname = new Pilot.URL(url).pathname;
                return /^(\/partner)?\/app\//.test(pathname);
            },
        });

        this._proxy(pilot);
    },

    /**
     * Проксирует все методы и свойства инстанса pilot в объект router,
     * чтобы в остальных модулях использовать роутер следующим образом:
     *     var router = require('./router');
     *     router.go('#route-id');
     */
    _proxy(pilot) {
        Object.setPrototypeOf(this, pilot);

        Object.keys(Pilot.prototype).forEach(function(key) {
            if (typeof Pilot.prototype[key] === 'function') {
                this[key] = function() {
                    // eslint-disable-next-line prefer-spread,prefer-rest-params
                    return pilot[key].apply(pilot, arguments);
                };
            }
        }, this);
    },

    handleRouteParams(params: any = {}) {
        if (!params) {
            params = {};
        }
        params.currentpid =
            params.currentpid ||
            // can't use getPid selector because of unsolving recursion
            CurrentUserModule.getModuleState(getStore().getState())
                .selectedPid ||
            // when user has no project
            'mcs0';
        return params;
    },

    redirectTo(routeId: string, params?, query?, details?) {
        this.go(routeId, params, query, {
            ...details,
            replaceState: true,
        });
    },

    getRoute(routeId) {
        return this.routes.find((route) => {
            return route.id === routeId;
        });
    },

    isPartnerAppUrl(url) {
        return String(url).startsWith('/partner/app');
    },

    isPartnerAppRequest(request) {
        return request && this.isPartnerAppUrl(request.path);
    },

    isPartnerAppRoute(route) {
        return (
            route &&
            route.url &&
            route.url.pattern &&
            this.isPartnerAppUrl(route.url.pattern)
        );
    },

    isPartnerApp() {
        return (
            this.isPartnerAppRoute(this.activeRoute) ||
            this.isPartnerAppRequest(this.activeRequest)
        );
    },

    changePid(pid: string) {
        window.location.href = this.activeRoute.getUrl(
            { ...this.activeRequest.params, currentpid: pid },
            { ...this.activeRequest.query, changedPid: true },
        );
    },

    isAfterPidChange() {
        return Boolean(this.activeRequest.query.changedPid);
    },
};

const pilotGetUrl = Pilot.prototype.getUrl;
Pilot.prototype.getUrl = function(id, params, query) {
    return pilotGetUrl.call(this, id, router.handleRouteParams(params), query);
};

const routeGetUrl = Pilot.Route.prototype.getUrl;
Pilot.Route.prototype.getUrl = function(params, query) {
    return routeGetUrl.call(this, router.handleRouteParams(params), query);
};

export default router as typeof router & {
    go(id: string, params?: any, query?: any, details?: any): void;
    nav(href, details?, forceReload?): void;
    reload(params, query?, details?): void;
    getUrl(id: string, params?: any, query?: any): string;
    activeRequest: any;
    activeRoute: any;
    routes: any[];
    on(action: string, callback: (...args: any[]) => any): any;
};
